import { useEffect, useState } from "react";
import { genericDownloadLink } from "src/data/variables";

declare global {
  interface Window {
    X: number;
  }
}

const useDevice = () => {
  const [deviceState, setDeviceState] = useState<string>();

  const getDevice = () => {
    const userAgent = navigator.userAgent;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return "iOS";
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // Opera detection
    if (/Opera|OPR\//i.test(userAgent)) {
      return "Opera";
    }

    return "unknown";
  };

  useEffect(() => {
    const device = getDevice && getDevice();

    if (device === "iOS" || device === "Android") {
      setDeviceState(device);
    }
  }, []);

  const getLink = () => {
    if (deviceState) {
      if (deviceState == "iOS") {
        return "https://apps.apple.com/us/app/redact-privacy/id6449900531";
      }
      return "https://play.google.com/store/apps/details?id=dev.redact.app";
    }
    return genericDownloadLink;
  };

  return { getLink };
};

export default useDevice;
